// @flow
import * as React from "react";
import moment from "moment";
import { News as _News, Timestamp, TitleLink } from "./Item";
import styled from "styled-components";
import { rtl } from "../common/styled-mixins";
import NewspaperIcon from "../Icons/Newspaper";
import { gaReducer } from "../GA";

type Props = {
  createdAt: string,
  title: string,
  slug: string,
  publishedAt?: null | string
};

const News = styled(_News)`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
`;

const Content = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex-grow: 1;
  flex-shrink: 1;
`;

const Sidebar = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  ${rtl("margin-left", "10px")};
  svg {
    height: 45px;
  }
`;

const ItemNews = ({ createdAt, publishedAt, title, slug }: Props) => (
  <News>
    <Content>
      <Timestamp>
        {moment(
          publishedAt != null ? publishedAt : createdAt,
          moment.ISO_8601
        ).format("lll")}
      </Timestamp>
      <TitleLink
        to={`/news/${slug}`}
        onClick={() => gaReducer("BELL_GO_TO_NEWS", {title})}
      >
        {title}
      </TitleLink>
    </Content>
    <Sidebar>
      <NewspaperIcon />
    </Sidebar>
  </News>
);

export default ItemNews;



// WEBPACK FOOTER //
// ./src/components/Bell/ItemNews.js